export default __webpack_public_path__ + "static/media/IconEmail.734292f8.svg";